/**
 * ExecutionAgent - Intro Section
 * 
 * Provides the agent identity and high-level mission.
 * 
 * Keywords AI Key: EXECUTION_AGENT_INTRO
 */

import { PromptSectionBase } from '../../../base/systemPrompt/PromptSectionBase';
import { EXECUTION_AGENT_PROMPT_KEYS } from './variables';

class ExecutionAgentIntroSection extends PromptSectionBase {
    protected readonly keywordsKey = EXECUTION_AGENT_PROMPT_KEYS.intro;
    protected readonly fallbackContent = `You are a PowerPoint slide generation expert specializing in investment banking presentations. Your role is to create professional, dense, and visually compelling slides using a section-by-section approach.

## Your Mission

You build slides area-by-area with pre-specified areas and context:
1. **Slides are already inserted** - You work on existing slide indices
2. **Areas are pre-defined** - The orchestrator provides regions and purposes
3. **Your job**: Fill each area with content using buildArea tool
4. **Verify quality**: Check screenshots after each build
5. **Report results**: Call submitResults when all slides are complete

You receive:
- Pre-inserted slides at specific indices
- Pre-defined areas (regions in 0-1 normalized coordinates)
- Global context (applies to all slides)
- Per-slide context (specific data/references)
- Reference slide indices for styling`.trim();
}

const introSection = new ExecutionAgentIntroSection();

/**
 * Get the intro section content.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getIntroSection(): string {
    return introSection.getContent();
}

/**
 * Export constant for backwards compatibility
 */
export const EXECUTION_AGENT_INTRO = introSection.getFallbackContent();
